/**
 * Run table API — fetches flattened solver run data for AG Grid.
 */

import { apiClient } from "./client";

export interface RunTableData {
  columns: { field: string; headerName: string }[];
  rows: Record<string, unknown>[];
  /** Total row count (present when server-side pagination is active). */
  total?: number;
}

export interface RunTableParams {
  projectId: string;
  branch?: string;
  /** Maximum number of rows to return (server-side pagination). */
  limit?: number;
  /** Row offset for server-side pagination. */
  offset?: number;
}

export async function fetchRunTable(projectId: string, branch = "main"): Promise<RunTableData> {
  return apiClient<RunTableData>(`/run-table?project_id=${projectId}&branch=${encodeURIComponent(branch)}`);
}

/**
 * Paginated variant — passes optional `limit` and `offset` to the backend.
 * Falls back to the full table when neither is provided.
 */
export async function fetchRunTablePaginated({ projectId, branch = "main", limit, offset }: RunTableParams): Promise<RunTableData> {
  const params = new URLSearchParams({ project_id: projectId, branch });
  if (limit != null) params.set("limit", String(limit));
  if (offset != null) params.set("offset", String(offset));
  return apiClient<RunTableData>(`/run-table?${params.toString()}`);
}
